import React from "react";
import { Button as ButtonAnt } from "antd";
import { ButtonProps } from "./button.model";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import "@companion-core/web/src/Assets/Styles/scss/button.scss";

export const Button = ({
  testID,
  type = "primary",
  negative = false,
  htmlType = "button",
  size = "default",
  disabled = false,
  label,
  icon,
  loading,
  classNames = [""],
  onClick,
  accessibilityLabel,
}: ButtonProps) => {
  const loadingBusy = !!loading;
  return (
    <ButtonAnt
      data-testid={testID}
      htmlType={htmlType}
      disabled={disabled}
      aria-label={accessibilityLabel}
      aria-busy={loadingBusy ? true : undefined}
      aria-disabled={loadingBusy ? true : undefined}
      className={[
        ...classNames,
        "button",
        type !== "link" ? "body-text-4" : "",
        !negative ? `button--${type}` : `button--${type}-negative`,
        size && `button--${size}`,
      ].join(" ")}
      loading={loading}
      {...(icon && {
        icon: <FontIcon name={icon} className="button__icon" aria-hidden="true" />,
      })}
      onClick={onClick}>
      <>{label}</>
    </ButtonAnt>
  );
};
